import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { usePurchaseSettlementMutation } from '@app/store/slices/settlements/settlementsApi';
import { useBalance } from '@app/shared/hooks/useBalance';
import { useApiErrorHandler } from '@app/shared/hooks/useApiErrorHandler';
import { telegramVibrate } from '@app/shared/utils/common';
import { Settlement as SettlementType } from '@app/store/slices/settlements/settlementsTypes';
import notification from '@app/shared/utils/notification';
import { Page } from '@app/routes';
import { PriceType } from '@app/shared/types/common';

export const usePurchaseSettlement = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isBalanceEnough } = useBalance();
  const { handleFetchError } = useApiErrorHandler();

  const [purchaseSettlementMutation, { isLoading: isPurchasingSettlement }] =
    usePurchaseSettlementMutation();

  const purchaseSettlement = async (
    settlement?: SettlementType | null,
    onSuccessCallback?: () => void
  ) => {
    if (!settlement) return;

    telegramVibrate();

    if (!isBalanceEnough(PriceType.TON, settlement.price)) {
      notification.error(t('errors.balance'));
      navigate(Page.SETTLEMENTS_SHOP);
      throw new Error();
    }

    try {
      const response = await purchaseSettlementMutation({
        settlementId: settlement.id,
        settlementPrice: settlement.price,
      }).unwrap();

      if (response.ok) {
        onSuccessCallback?.();
        notification.success(t('settlements.build_success', { settlementTitle: settlement.name }));
      }
    } catch (err) {
      handleFetchError(err);
    }
  };
  return {
    purchaseSettlement,
    isPurchasingSettlement,
  };
};
